import { Link, useLocation, useNavigate } from "react-router-dom";
import { User, LogOut, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import useAuth from "@/hooks/useAuth";
import useIsMobile from "../hooks/useIsMobile";
import { ROUTES_PATH } from "@/router";

export default function Navbar() {
  const { user, onSignOut } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  if (isMobile && pathname.startsWith(ROUTES_PATH.ACCOUNT)) {
    return null;
  }
  return (
    <header className="bg-background border-b border-border">
      <div className="flex items-center justify-between py-3 	px-4">
        <Link
          className="flex items-center space-x-2"
          to={user?.id ? ROUTES_PATH.DASHBOARD : ROUTES_PATH.LOGIN}
        >
          <img
            src="/images/4ee90ee9-5220-48c2-8fc0-11a0de4664cd.png"
            alt="StartFLY Logo"
            className="h-14"
          />
        </Link>
        <div className="flex items-center">
          {user?.id ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button
                  variant="ghost"
                  className="flex h-12 w-12 rounded-full items-center [&_svg]:size-7"
                >
                  <User />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end" className="w-60">
                <DropdownMenuLabel className="flex items-center gap-2 font-normal text-muted-foreground my-2">
                  <Mail className="h-3.5 w-3.5 shrink-0" />
                  <span className="truncate text-xs">{user?.email}</span>
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={() => navigate(ROUTES_PATH.PROFILE)}
                  className={
                    pathname === ROUTES_PATH.PROFILE
                      ? "bg-accent text-accent-foreground"
                      : ""
                  }
                >
                  <User className="h-4 w-4 mr-2" />
                  Mi Perfil
                </DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem
                  onClick={onSignOut}
                  className="text-destructive focus:text-destructive"
                >
                  <LogOut className="h-4 w-4 mr-2" />
                  Cerrar Sesión
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Link to={ROUTES_PATH.LOGIN}>
              <Button variant="ghost">Iniciar Sesión</Button>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
